import { apiWrapper } from 'ccs-ui-components';
import { call, fork, put, takeLatest } from 'redux-saga/effects';
import { headersInstance } from '../../../../common/utils/HeaderUtils';
import { IEvent } from '../../../models/index';
import { getEventType } from '../../actions/actionType/events/EventActionTypes';
import {
  clearEvents,
  fetchEventFailure,
  fetchEventStarted,
  fetchEventSuccess
} from '../../actions/sagaActions/events/EventNameSagaActions';
import {
  FetchEventFailurePayload,
  FetchEventRequest
} from '../../actions/types/events/FetchEventDetailTypes';

/**
 * Call Gets Events by Name API
 * @param eventName : string
 * @param status : string
 * @returns api response
 */
export async function callGetEventApi(eventName: string, version: number) {
  return apiWrapper.get<IEvent>(
    `${process.env.REACT_APP_API_CONTROL_PLANE_BASE_URL}/events/${eventName}/version/${version}`,
    headersInstance()
  );
}

/**
 * Saga to get Event by eventName
 * @param eventName:string
 */
export function* getEventByEventName({ eventName, version }: FetchEventRequest) {
  yield put(clearEvents());
  yield put(fetchEventStarted());
  try {
    const { responseBody: data, isError, error } = yield call(callGetEventApi, eventName, version);
    if (isError) {
      throw error;
    }
    if (data) {
      yield put(fetchEventSuccess(data));
    } else {
      throw new Error('No Response');
    }
  } catch (error) {
    const obj: FetchEventFailurePayload = {
      error: String(error)
    };
    yield put(fetchEventFailure(obj));
  }
}

/**
 * Saga Effect to consider latest request
 */
export function* fetchEventSaga() {
  yield takeLatest(getEventType.FETCH_EVENT_REQUEST, getEventByEventName);
}

export const getEventSaga = [fork(fetchEventSaga)];
